import { render } from "./Widget8.vue?vue&type=template&id=55d1c362"
import script from "./Widget8.vue?vue&type=script&lang=js"
export * from "./Widget8.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__